<template>
  <b-card>
    <div slot="header">
      <strong>Inventario - Actualizar columna</strong>
       <div class="float-right">
          <router-link
            to="/inventory/columns"
            class="btn btn-secondary mx-0 btn-sm"
            ><i class="fa fa-reply fa-lg"></i> Volver
          </router-link>
        </div>
    </div>
    <div>
    
      <Form @onAction="update" methodForm="PUT" scopeForm="update" />
       
    </div>
  </b-card>
</template>
<script>

//  Generales
import { mapActions, mapMutations, mapState } from "vuex";

// Componentes
import Form from "../components/columns/Form.vue";

export default {

  components: {
    Form,
  },

  async mounted() {
    this.load(false);
    await this.getColumById(this.$route.params.id);
  },

  computed: {
    ...mapState("colums", ["column"]),
  },

  methods: {

    ...mapActions("colums", ["getColumById", "updateColumn"]),    
    ...mapMutations("dashboard", ["load"]),

    ...mapMutations("colums", ["setColumn"]),

    async update() {
      this.$validator.validateAll("update").then(async (result) => {
        if (result) {
          const payload = {
              ...this.column,
              danger_fields_id: this.column.danger_fields_id.map(x => x.id),
              separator_to_grouped_fields: ['', null,'blank-space'].find(x => x === this.column.separator_to_grouped_fields) ? 'blank-space' : this.column.separator_to_grouped_fields
          }
          await this.updateColumn({ payload, callback: this.callbackUpdate });
        }
      });
    },

    callbackUpdate(success) {
      if(!success) return false;

      this.$router.push("/inventory/columns");
    }

  }
};
</script>
